export interface StatItem {
  label: string;
  value: string | number;
  subtext?: string;
}

export default function StatGrid({ items }: { items: StatItem[] }) {
  return (
    <div className="bg-white border border-secondary-200 rounded-lg grid grid-cols-2 lg:grid-cols-4">
      {items.map((item) => (
        <div key={item.label} className="px-5 py-4">
          <p className="text-xs font-medium text-secondary-400 uppercase tracking-[.06em] mb-1">
            {item.label}
          </p>
          <p className="font-mono text-[22px] font-semibold text-secondary-900 leading-none tracking-tight">
            {item.value}
          </p>
          {item.subtext && (
            <p className="mt-1 text-xs text-secondary-500">{item.subtext}</p>
          )}
        </div>
      ))}
    </div>
  );
}
